import React from 'react';

const SuggestionChip = ({ text, onClick, isDark = false }) => {
  const defaultBg = isDark ? '#21262d' : '#f5f5f5';
  const defaultColor = isDark ? '#adbac7' : '#595959';
  const hoverBg = isDark ? '#30363d' : '#e6f7ff';
  const hoverColor = isDark ? '#4096ff' : '#1890ff';
  const hoverBorder = isDark ? '#4096ff' : '#1890ff';

  return (
    <div
      onClick={onClick}
      style={{
        display: 'inline-block',
        padding: '10px 20px',
        backgroundColor: defaultBg,
        borderRadius: '20px',
        cursor: 'pointer',
        fontSize: '14px',
        color: defaultColor,
        transition: 'all 0.2s ease',
        border: '1px solid transparent',
        userSelect: 'none',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = hoverBg;
        e.currentTarget.style.borderColor = hoverBorder;
        e.currentTarget.style.color = hoverColor;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = defaultBg;
        e.currentTarget.style.borderColor = 'transparent';
        e.currentTarget.style.color = defaultColor;
      }}
    >
      {text}
    </div>
  );
};

export default SuggestionChip;